"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var arrow_left_icon_new_svg_1 = __importDefault(require("@assets/widgets/app/arrow-left-icon-new.svg"));
var arrow_left_icon_disabled_svg_1 = __importDefault(require("@assets/widgets/app/arrow-left-icon-disabled.svg"));
var arrow_right_icon_new_svg_1 = __importDefault(require("@assets/widgets/app/arrow-right-icon-new.svg"));
var arrow_right_icon_disabled_svg_1 = __importDefault(require("@assets/widgets/app/arrow-right-icon-disabled.svg"));
var react_i18next_1 = require("react-i18next");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        pageSelectGrid: (_a = {
                fontWeight: 500,
                color: '#767676',
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
                height: '100%',
                zIndex: 1
            },
            _a[theme.breakpoints.down('sm')] = {
                justifyContent: 'center',
            },
            _a.paddingRight = 10,
            _a),
        pageSelectGridDirectory: {
            fontWeight: 500,
            color: '#767676',
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            zIndex: -1,
        },
        gridItemHorizontalPadding: {
            color: theme.palette.primary.main,
            '&:first-child': {
                paddingRight: 10,
            },
            '&:last-child': {
                paddingLeft: 10,
            },
        },
        currentPage: {
            border: '1px solid #FFC700',
            borderRadius: '4px',
            padding: '4px 10px',
            color: '#FFC700',
            margin: '0 10px',
        },
        pageCount: {
            border: '1px solid #FFC700',
            borderRadius: '4px',
            padding: '4px 10px',
            color: '#FFC700',
            marginLeft: 10,
        },
    });
});
var PaginationActionComponent = function (_a) {
    var pageCount = _a.pageCount, onChangePage = _a.onChangePage, page = _a.page, _b = _a.disablePagination, disablePagination = _b === void 0 ? false : _b;
    var _c = __read(react_i18next_1.useTranslation(), 1), t = _c[0];
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, alignItems: "center", className: disablePagination
            ? classes.pageSelectGridDirectory
            : classes.pageSelectGrid },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function (event) { return onChangePage(event, page - 1); }, disabled: page <= 0 },
                react_1.default.createElement("img", { height: "28px", src: page <= 0 ? arrow_left_icon_disabled_svg_1.default : arrow_left_icon_new_svg_1.default, alt: "Previous page", draggable: false }))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            t('text.pages'),
            react_1.default.createElement(core_1.Box, { className: classes.currentPage, component: "span" }, page + 1),
            t('text.of'),
            react_1.default.createElement(core_1.Box, { className: classes.pageCount, component: "span" }, pageCount)),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function (event) { return onChangePage(event, page + 1); }, disabled: pageCount <= page + 1 },
                react_1.default.createElement("img", { height: "28px", src: pageCount <= page + 1 ? arrow_right_icon_disabled_svg_1.default : arrow_right_icon_new_svg_1.default, alt: "Next page", draggable: false })))));
};
exports.default = PaginationActionComponent;
